const HowToEnrollUsers = () => (
  <div>
    <div className="text-primary border-2 mb-4 bg-grays-light border-primary rounded px-4 py-2">
      <strong>Note:</strong> Users can now enroll themselves in Virtual
      Classroom. Please refer to the General Users FAQ page for Virtual
      Classroom instructions. If you want to assign a Virtual Classroom session
      to one of your users, they are still required to follow the General Users
      steps.
    </div>
    <ol className="list-decimal list-inside text-grays-dark space-y-4">
      <li>
        Log into{' '}
        <a className="underline text-blue-800" href="http://ctionline.com/">
          CTI Online
        </a>
      </li>
      <li>
        Click the <strong>Account</strong> icon in the top right corner of the page next to the shopping cart and click on <strong>admin</strong> (Manager credentials are required for these features)
        <div className="my-4 border rounded">
          <img src="/images/faqs/ham_menu_hided.png" alt="Admin Panel" />
        </div>
      </li>
      <li>
        Click on <strong>Admin</strong>, <strong>Enroll Users</strong> then click on <strong>Instructor-Led Training</strong> or <strong>Online Training</strong>.  If your shop has multiple subscriptions, you will need to assign training from one subscription at a time
        <div className="my-4 border rounded">
          <img src="/images/faqs/SelectSubscription1.png" alt="Admin Panel" />
        </div>
      </li>
      <li>
        Select the <strong>Subscription</strong> from the <strong>drop-down menu</strong> (this example shows the Advanced Online Learning subscription)
        <div className="my-4 border rounded">
          <img
            src="/images/faqs/SelectClasses1.png"
            alt="Select Subscription"
          />
        </div>
      </li>
      <li>
        Select the class(es) or learning plan(s) to enroll - The filter box is helpful when you type a key word to narrow your search
      </li>
      <li>
        Select the User(s) to enroll
      </li>
      <li>
        Click <strong>Enroll Users</strong>
      </li>
      <li>
        All enrolled classes will show up on the user’s Training Homepage in the <strong>My Tasks</strong> section
        <div className="my-4 border rounded w-full justify-center flex">
          <img
            src="/images/faqs/EnrolledClasses1.png"
            alt="Select Subscription"
          />
        </div>
      </li>
      <li>
        For Instructor-Led Training (in-person and Virtual Classroom) click on <strong>Instructor-Led Training</strong> then select the Subscription from the <strong>drop-down menu</strong> (this example shows the Virtual Classroom Unlimited subscription)
        <div className="my-4 border rounded">
          <img src="/images/faqs/ILT1.png" alt="Enroll Students" />
        </div>
      </li>
      <li>
        Select the class(es) to enroll - The filter box is helpful when you type a key word to narrow your search
      </li>
      <li>
        Select the User(s) to enroll (You can also Unenroll users from Instructor-Led classes here)
      </li>
      <li>
        All enrolled Instructor-Led classes will show up on the user’s homepage in the My Training Calendar section 
      </li>
      <li>
        Click on the class in the calendar section to view more details including class dates and times, location (for in-person classes) and a link to the class workbook
        <div className="my-4 border rounded w-full justify-center flex">
          <img src="/images/faqs/ClassCalendar1.png" alt="Enroll Students" />
        </div>
      </li>
      <p>
        Need help with these instructions? Please contact{" "}
        <a
          href="mailto:ctisupport@carquest.com"
          className="text-blue-600 hover:text-blue-800 transition"
        >
          ctisupport@carquest.com
        </a>
      </p>
    </ol>
  </div>
)

export default HowToEnrollUsers
